<template>
    <div>
        <cell-group style="padding-bottom: 80px;">
            <div v-for="item in list" class="formstyle">
                <field v-if="item.type == 1"  v-model="ruleForm[item.key_name]" clearable :required="item.required == 1" @input="changeicon(item,ruleForm[item.key_name])" :label="item.show_name" :placeholder="item.placeholder?item.placeholder:'请输入'+item.show_name" :right-icon="item.type != 1 ? 'arrow' : ''"/>
                <field v-else v-model="ruleForm[item.key_name]" clearable readonly :required="item.required == 1" :label="item.show_name" :placeholder="item.placeholder?item.placeholder:'请输入'+item.show_name" @click="onOpen(item,ruleForm[item.key_name])" right-icon="arrow"/><Icon v-if="showic[item.key_name]" :name="icon[item.key_name]" :color="color[item.key_name]" />
            </div>
        </cell-group>
        <div class="footer apppadding">
            <div class="agree" v-if="isterm"> 
                <Checkbox v-model="showterm" shape="square" @change="onChange"></Checkbox>已阅读并同意<span @click="godisclaimer" style="color: #ff8c5f">《参赛声明》</span>
            </div>
            <Button type="warning" @click="signUp" size="large" :disabled="!agree" round>{{isterm ? '创建团队' : '确认'}}</Button>
        </div> 
        <Popup  v-model="show" position="bottom" :overlay="true" >
            <Picker v-if="type==3||type==9" show-toolbar :columns="options" @cancel="onCancel" @confirm="onConfirm"/>
            <Area v-else-if="type==8" :area-list="areaList" @cancel="onCancel" @confirm="onConfirm"  />
            <datetime-picker v-else :min-date="minDate" type="date" @cancel="onCancel" @confirm="onConfirm"/>
        </Popup>
    </div>
</template>

<script>
    import moment from 'moment';
    import './index.less'
    import areadeil from'./area.js'
    import { fromatMatchTime,formatTime } from '@/libs/utils'
    import {CellGroup, Button, Field, Picker, Popup, Area, Icon, Checkbox,DatetimePicker} from 'vant';
    export default {
        name: 'formpage',
        components: {
            Field,
            CellGroup,
            Button,
            Picker,
            Popup,
            Area,
            Icon,
            Checkbox,
            DatetimePicker
        },
        data() {
            return {
                show: false,
                options: [],
                onedata: [],
                ruleForm:{},
                showterm: false,
                icon: {},
                color: {},  
                showic: {},
                agree: false,
                type: 0,
                currentDate: false,
                minDate: new Date(1919, 0, 0),
                areaList: areadeil,
                shenfen:true  
            }
        },
        filters:{

        },
        props: {
            list: Array,
            isterm: {
                type:Boolean,
                default:false
            }
        },
        watch:{
            list: {
                deep: true,
                handler(val) {
                   this.setOptions(val)
                }
            }
        },
        methods:{
            signUp:function(e){ 
                console.log(this.ruleForm,this.showic,this.icon,this.color,this.list)
                let go = true
                this.list.forEach((value,index)=>{
                    this.$set(this.showic,value.key_name,true)
                    for(let i in this.ruleForm)
                    {    
                        if(value.key_name==i)
                        {   
                            if(value.required == 1){
                                value.value =  this.ruleForm[i];
                                var reg= eval(value.rules) == null ? undefined : eval(value.rules)
                                var pattern=new RegExp(reg);
                                var isshow = pattern.test(value.value)
                                var name = isshow == true ? 'checked' : 'fail'
                                var color = isshow == true ? '#57bd6b' : '#ec5351'
                                this.$set(this.icon,value.key_name,name)
                                this.$set(this.color,value.key_name,color)
                            }else{
                                value.value =  this.ruleForm[i];
                                var name = 'checked'
                                var color = '#57bd6b' 
                                this.$set(this.icon,value.key_name,name)
                                this.$set(this.color,value.key_name,color)
                            }
                            
                        }
                    }
                })
                this.list.forEach((value,index)=>{
                    if(!value.value){
                        if(value.required == 1){
                            this.$set(this.icon,value.key_name,'fail')
                            this.$set(this.color,value.key_name,'#ec5351')
                        }else{
                            this.$set(this.icon,value.key_name,'checked')
                            this.$set(this.color,value.key_name,'#57bd6b')
                        }     
                    }
                })
                for(let j in this.icon){
                    if(this.icon[j] == 'fail'){
                        go = false
                    }
                } 
                if(go == true){
                    this.$emit('getAuth', this.list)
                }   
            },
            onOpen(e,val){
                this.onedata = e
                this.show = true
                if(e.type == 7){
                   this.type = 7
                }else if(e.type == 8 ){
                   this.type = 8
                }else{
                    this.type = e.type
                    this.options = []
                    for(let i=0,len=e.options.length;i<len;i++){
                       this.options.push(e.options[i].value) 
                    }
                }  
            },
            onCancel(e){
                this.show = false
            },
            onConfirm(event,index){                  
                if(this.type == 7){
                   event = formatTime(event)
                }else if(this.type == 8){
                   event = event[0].name+','+event[1].name+','+event[2].name
                }
                this.$set(this.ruleForm,this.onedata.key_name,event)
                this.changeicon(this.onedata,event)
                this.show = false
            },
            changeicon(item,val){
                if(item.key_name=="mv_idtype"){
                    if(val=="身份证") this.shenfen = true;
                    else this.shenfen = false;
                }else if(item.key_name=="mv_idnumber"){ 
                    if(this.shenfen){
                        var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
                        if(reg.test(val)){
                            let sex = val.slice(16, 17)
                            let se = sex%2==0?'女':'男'
                            let brith = val.slice(6, 14)
                            console.log(sex,se,brith)
                            this.$set(this.ruleForm,'mv_sex',se)
                            this.$set(this.ruleForm,'mv_birth',brith)
                        }
                    }
                }
                this.$set(this.showic,item.key_name,true)
                if(item.key_name=="mv_idnumber"&&this.shenfen){
                    var isshow = val == '' ? false : reg.test(val)
                }else{
                    var reg= eval(item.rules) == null ? undefined : eval(item.rules)
                    var pattern=new RegExp(reg);
                    var isshow = val == '' ? false : pattern.test(val)
                }
                
                var name = isshow == true ? 'checked' : 'fail'
                var color = isshow == true ? '#57bd6b' : '#ec5351'
                this.$set(this.icon,item.key_name,name)
                this.$set(this.color,item.key_name,color)
                
            },
            setOptions(list){
                if(this.isterm == false){
                    this.agree = true
                }else{
                    this.agree = false
                }
                list.forEach((value,index)=>{
                    if(value.value){
                        this.$set(this.ruleForm,value.key_name,value.value)
                    }else{
                        if(value.type == 3||value.type == 9){
                            if(typeof(value.options)=='string') value.options = JSON.parse(value.options);
                            this.$set(this.ruleForm,value.key_name,value.options[0].value)
                        }
                    }
                })
            },
            onChange(event){
               this.agree = event
            },
            godisclaimer(){
                this.$emit('goterm', '条款')
            }
        },
        mounted() {
            this.setOptions(this.list)
        }
    }
</script>